import $ from 'jquery';
import UIkit from 'uikit';
window.addEventListener('px-ready',function(){
    $('.categ-selector').on('change',function(){
        var value = $(this).find(':selected').val();
        if(!value){
            $('.news-link.is-blog').css('display','block');    
        }else{
            $('.news-link.is-blog').each(function(){
                $(this).css('display','none');
                var thiscategs = $(this).attr('term-id');
                if(thiscategs.includes(value)){
                    $(this).css('display','block');
                }
            })
        }
    })
})